import { RoomType } from "./C1_RoomTypes";

export const FurnitureCategory = {
  ...RoomType,
  All: "all",
  None: "none",
  Decoration: "decoration",
  Electrical: "electrical",
  ElectricalEquipment: "electrical-equipment",
  Outdoor: "outdoor",
} as const;

export type FurnitureCategory = (typeof FurnitureCategory)[keyof typeof FurnitureCategory];
